import React from 'react';

import Monitor from './Monitor';
import Top from './Top';
import useOrganizer from '../useOrganizer';

import Frame from '@/components/ui/dashboard/Frame';
import useModeByStatus from '@/hooks/useModeByStatus';

const Dashboard = ({ data: robot }) => {
  const mode = useModeByStatus(robot);
  useOrganizer(robot);

  return (
    <Frame robot={robot} mode={mode} top={<Top robot={robot} />}>
      <Monitor robotId={robot.id} />
    </Frame>
  );
};

export default Dashboard;
